import { VoyageRoute } from "../models/voyage-routing-model";
import { authFetchPOST } from "../utils/auth-fetch";

const env = (<any>window)["appenv"].services.encapi;

export const EncService = new class extends EventTarget {
    async postEncAugmentRouteJob(route: VoyageRoute): Promise<VoyageRoute|null> {
        const payload = {inputRoute: route};
        let postResult;
        try {
            postResult = await authFetchPOST(env.scope, `${env.baseurl}/augmentroute`, payload);
        } catch(err) {
            console.log("ERR ", err, postResult)
        }
        
        if (!postResult) {
            console.warn('Error returned from ENC API', postResult);
            return null;
        }
        return postResult.inputRoute;
    }
}
